var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeneficios3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #feecb0;\n      }\n\n      .cls-2 {\n        fill: #414141;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M168.21,105.74c0,40.77-33.17,73.94-73.95,73.94S20.31,146.51,20.31,105.74,53.49,31.79,94.26,31.79s73.95,33.17,73.95,73.95Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100,173.95c-40.78,0-73.95-33.17-73.95-73.95S59.22,26.05,100,26.05s73.95,33.17,73.95,73.95-33.17,73.95-73.95,73.95Zm0-141.13c-37.04,0-67.18,30.14-67.18,67.18s30.14,67.18,67.18,67.18,67.18-30.14,67.18-67.18-30.14-67.18-67.18-67.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100,109.93c-1.87,0-3.38-1.51-3.38-3.38V59.29c0-1.87,1.51-3.38,3.38-3.38s3.38,1.51,3.38,3.38v47.26c0,1.87-1.51,3.38-3.38,3.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.58,121.25c-1.29,0-2.52-.74-3.09-2-.77-1.7,0-3.71,1.7-4.48l43.09-19.4c1.7-.77,3.71,0,4.48,1.7s0,3.71-1.7,4.48l-43.09,19.4c-.45,.2-.92,.3-1.39,.3Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeneficios3);
export default __webpack_public_path__ + "static/media/beneficios3.2a275ff72145e729bc42e7931280795c.svg";
export { ForwardRef as ReactComponent };